import { defineStore, acceptHMRUpdate } from 'pinia'

type IState = {
  locales: string[]
  locale: string
}
/**
 * 城市选择器数据存储
 */
const defaultState = {
  locales: ['en_US'],
  locale: 'en_US',
}

const indexStore = defineStore('indexStore', {
  state: (): IState => defaultState,
  actions: {
    SET_LOCALE(payload: string) {
      this.locale = payload
    },
  },
})

export default indexStore

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(indexStore, import.meta.hot))
}
